import { osRotas as rotasOs } from "@/views/OS";
import { diarioObraRotas as rotasDiario } from "@/views/DiarioObra";
import { creObrasRotas } from "@/views/CREObras";
import { rotaContratoRestrita } from "@/views/Contratos";
import { rotaComObra } from "@/views/Materiais";
import { rotaBibliotecaObra } from "@/views/Biblioteca";
import { rotaAdicionarUsuarioObra } from "@/views/ControleAcesso";

export const rotaObras = [
  {
    path: "/obras",
    name: "Obras",
    component: () => import("@/views/Obra/ObrasHome.vue"),
    title: "Início",
    meta: {
      title: "Início",
      acessoRapido: false,
      showMenu: false,
      emManutencao: false,
    },
  },
];

export const rotasObraDashboards = [
  {
    path: "/todas-obras",
    name: "Todas Obras",
    component: () => import("@/views/Obra/TodasObras.vue"),
    title: "Todas Obras",
    meta: {
      title: "Todas Obras",
      icon: "mdi-home-search-outline",
      subject: ["Obra"],
      acessoRapido: false,
      showMenu: true,
      emManutencao: false,
    },
  },
  {
    path: "/dashobras-obras",
    name: "Dashboard Obras",
    component: () => import("@/views/Obra/DashboardObras.vue"),
    title: "Dashboard Obras",
    meta: {
      title: "Dashboard Obras",
      icon: "mdi-view-sequential",
      subject: ["Obra"],
      action: ["seeAll"],
      acessoRapido: false,
      showMenu: true,
      emManutencao: false,
    },
  },
];

export const rotasObraGeral = [
  {
    path: "/obra",
    name: "Nova Obra",
    component: () => import("@/views/Obra/NovaObra.vue"),
    meta: {
      title: "Nova Obra",
      icon: "mdi-plus",
      subject: ["Obra"],
      action: ["create"],
      showMenu: true,
      grupo: "OBRA",
      grupoTitle: "Obra",
    },
  },
  {
    path: "/obra/documentacao",
    name: "Árvore de documentos",
    component: () => import("@/views/Obra/ConfigurarDocumentos.vue"),
    meta: {
      title: "Árvore de documentos",
      icon: "mdi-file-tree",
      subject: ["Obra"],
      action: ["configure"],
      showMenu: true,
      grupo: "OBRA",
      grupoTitle: "Obra",
    },
  },
];

export const rotaObraRestrita = [
  {
    path: "/obras/:obra",
    layoutNome: "LayoutObra",
    component: () => import("@/layout/LayoutObra.vue"),
    meta: {
      icon: "mdi-mdi-account",
      showMenu: false,
    },
    children: [
      {
        path: "",
        name: "Dashboard",
        component: () => import("@/views/Obra/DashboardDaObra.vue"),
        meta: {
          obraObrigatoria: false,
          title: "Dashboard",
          icon: "mdi-view-dashboard-outline",
          showMenu: true,
        },
      },
      ...rotaBibliotecaObra,
      {
        path: "galeria",
        name: "Galeria de Obra",
        component: () => import("@/views/Obra/GaleriaObra.vue"),
        meta: {
          breadcrumb: "Dashboard",
          title: "Galeria de Obra",
          icon: "mdi-folder-multiple-image",
          subject: ["Obra"],
          action: ["read"],
          showMenu: true,
        },
      },
      ...rotaAdicionarUsuarioObra,
      {
        path: "atualizar",
        name: "Atualizar Obra",
        component: () => import("@/views/Obra/UpdateObra.vue"),
        meta: {
          breadcrumb: "Dashboard",
          title: "Atualizar Obra",
          icon: "mdi-pencil",
          subject: ["Obra"],
          action: ["update"],
          showMenu: true,
          grupo: "OBRA",
          grupoTitle: "Obra",
        },
      },
      {
        path: "informacoes",
        name: "Todas Informações",
        component: () => import("@/views/Obra/TodasInformacoes.vue"),
        meta: {
          title: "Todas Informações",
          breadcrumb: "Dashboard",
          icon: "mdi-plus",
          subject: ["Obra"],
          action: ["inspect"],
          showMenu: true,
          grupo: "OBRA",
          grupoTitle: "Obra",
        },
      },
      ...creObrasRotas["obra"],
      ...rotaContratoRestrita,
      ...rotasOs,
      ...rotasDiario,
      ...rotaComObra,
    ],
  },
];
